export default "__VITE_ASSET__BTeTEA4U__"